(() => {
  if (window.awAuraDocuments) return;
  window.awAuraDocuments = true;
  const identify = text => {
    const label = text.trim().replace(/\s+/g, ' ').replace(/:$/, '').trim().toLowerCase();
    return /^(sds|msds|safety data sheet)$/.test(label) ? 'sds' : /^(test reports?|test report documents?)$/.test(label) ? 'report' : null;
  };
  function enhance() {
    document.querySelectorAll('[data-aw-description]').forEach(root => {
      const documents = [...root.querySelectorAll('a[href]')].filter(a => !a.closest('.aw-documentation') && identify(a.textContent));
      if (!documents.length) return;
      let panel = root.querySelector('.aw-documentation');
      if (!panel) {
        panel = document.createElement('section');
        panel.className = 'aw-documentation';
        const heading = document.createElement('h3');
        heading.textContent = root.dataset.docHeading;
        const note = document.createElement('p');
        note.textContent = root.dataset.docNote;
        const list = document.createElement('div');
        list.className = 'aw-document-links';
        panel.append(heading, note, list);
        root.append(panel);
      }
      documents.forEach(a => {
        const kind = identify(a.textContent);
        let prev = a.previousSibling;
        while (prev && ((prev.nodeType === 3 && /^[\s:]*$/.test(prev.textContent)) || (prev.nodeType === 1 && prev.tagName === 'BR'))) {
          const next = prev.previousSibling;
          prev.remove();
          prev = next;
        }
        if (prev && prev.nodeType === 1 && /^(STRONG|B|SPAN)$/.test(prev.tagName) && identify(prev.textContent) === kind) prev.remove();
        if (a.nextSibling?.nodeName === 'BR') a.nextSibling.remove();
        a.className = 'aw-document-link';
        a.textContent = '';
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.className = 'aw-document-icon';
        icon.textContent = '↓';
        const label = document.createElement('span');
        label.textContent = kind === 'sds' ? root.dataset.docSds : root.dataset.docReport;
        a.append(icon, label);
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        const parent = a.parentElement;
        panel.querySelector('.aw-document-links').append(a);
        if (parent !== root && parent.tagName === 'P' && !parent.textContent.trim() && !parent.querySelector('img,video,iframe')) parent.remove();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance); else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
